document.addEventListener('DOMContentLoaded', function() {
  const dropdownToggles = document.querySelectorAll('[data-dropdown-toggle]');

  function closeAllDropdowns() {
    dropdownToggles.forEach(toggle => {
      const item = toggle.closest('.header-custom__nav-item');
      if (item) {
        item.classList.remove('is-open');
      }
      toggle.setAttribute('aria-expanded', 'false');
    });
  }

  dropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const item = toggle.closest('.header-custom__nav-item');
      if (!item) {
        return;
      }
      const isOpen = item.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.header-custom__nav-item')) {
      closeAllDropdowns();
    }
  });
});
